import { useTranslation } from "react-i18next";
import {
  NavItem,
  NavList,
  NavSection,
  SidebarContainer,
  SidebarContextHeader,
  StyledNavLink,
} from "../../components/SidebarComponents";
import { useIsAdmin } from "../../hooks/useIsAdmin";
import { MobileDrawerFooter, MobileDrawerHeader } from "../components/AppNavbar";
import { HelpCenterSidebarLink } from "../help/HelpCenterSidebarLink";

interface ResellerSidebarProps {
  resellerId: string | null;
  onNavigate?: () => void;
}

export const ResellerSidebar = ({ resellerId, onNavigate }: ResellerSidebarProps) => {
  const { t } = useTranslation();
  const isAdmin = useIsAdmin();

  if (!resellerId) return null;

  const handleClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <SidebarContainer>
      <MobileDrawerHeader onNavigate={handleClick} />
      <NavList>
        <NavSection>
          <SidebarContextHeader resellerId={resellerId} onNavigate={handleClick} />
          <NavItem>
            <StyledNavLink to="overview" end onClick={handleClick}>
              {t("resellerSidebar.overview")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="stores" onClick={handleClick}>
              {t("resellerSidebar.stores")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="users" onClick={handleClick}>
              {t("resellerSidebar.users")}
            </StyledNavLink>
          </NavItem>
          <NavItem>
            <StyledNavLink to="priceList" onClick={handleClick}>
              {t("resellerSidebar.priceList")}
            </StyledNavLink>
          </NavItem>
          {isAdmin && (
            <>
              <NavItem>
                <StyledNavLink to="invoicing" onClick={handleClick}>
                  {t("resellerSidebar.invoicing")}
                </StyledNavLink>
              </NavItem>
              <NavItem>
                <StyledNavLink to="availableBillingItems" onClick={handleClick}>
                  {t("resellerSidebar.availableBillingItems")}
                </StyledNavLink>
              </NavItem>
            </>
          )}
        </NavSection>
      </NavList>
      <HelpCenterSidebarLink />
      <MobileDrawerFooter />
    </SidebarContainer>
  );
};
